"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = require("react-dom/client");
var react_query_1 = require("@tanstack/react-query");
var Navigation_1 = require("./components/Navigation");
var Masthead_1 = require("./components/Masthead");
var CheckoutTabs_1 = require("./components/CheckoutTabs");
var queryClient = new react_query_1.QueryClient();
function Checkout() {
    return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
        react_1.default.createElement(Navigation_1.Navigation, null),
        react_1.default.createElement(Masthead_1.Masthead, null),
        react_1.default.createElement(CheckoutTabs_1.CheckoutTabs, null)));
}
exports.Checkout = Checkout;
var domContainer = document.getElementById("reactRoot");
if (domContainer) {
    var root = (0, client_1.createRoot)(domContainer);
    root.render(react_1.default.createElement(Checkout, null));
}
